/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/164-spoon-knife': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655.985 3.042 2.308 3.406l-.497 8.096A.931.931 0 003.25 16h.5c.55 0 .972-.449.939-.998l-.497-8.096C5.515 6.541 6.5 5.155 6.5 3.5c0-1.933-1.343-3.5-3-3.5zm10.083 0l-.833 5h-.625l-.417-5h-.417l-.417 5h-.625l-.833-5h-.417v6.5a.5.5 0 00.5.5h1.302l-.491 8.002a.931.931 0 00.939.998h.5c.55 0 .972-.449.939-.998L12.197 7h1.302a.5.5 0 00.5-.5V0h-.417z"/>'
  }
})
